"use client";
import { useEffect, useReducer, useState } from "react";
import React from "react";
import { getAnalytics, setUserId, logEvent } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { useSession } from "next-auth/react";
import PropTypes from "prop-types";
import Smartlook from "smartlook-client";
import TiktokPixel from "tiktok-pixel";
import FirebaseContext from "./firebaseContext";
import FirebaseReducer from "./firebaseReducer";

const FirebaseState: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const session = useSession();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (session.status != "loading" && !mounted) {
      initFirebase();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENVIRONMENT_AS_DEVELOPMENT !== "true") {
      import("react-facebook-pixel")
        .then((x) => x.default)
        .then((ReactPixel) => {
          ReactPixel.init("434509136312456"); // facebookPixelId
          ReactPixel.pageView();
        });
      TiktokPixel.init("CTCOV5BC77U38DUS93L0", {}, { debug: false });
      //TiktokPixel.pageView();
    }
  }, []);

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENVIRONMENT_AS_DEVELOPMENT !== "true") {
      if (Smartlook.initialized()) {
        if (session.data) {
          Smartlook.identify(session.data.user.email, {
            mail: session.data.user.email,
          });
        }
      } else {
        Smartlook.init(process.env.NEXT_PUBLIC_SMARTLOOK_API_KEY ?? "", {
          region: "eu",
        });
        if (session.data) {
          Smartlook.identify(session.data.user.email, {
            mail: session.data.user.email,
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);

  const initialState = {
    firebaseInstance: undefined,
    firebaseAnalytics: undefined,
  };

  const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
  };

  const [state, dispatch] = useReducer(FirebaseReducer, initialState);

  const initFirebase = () => {
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    if (session.data) {
      setUserId(analytics, session.data.user.email);
    }
    setMounted(false);
    dispatch({
      type: "SAVE_FIREBASE_APP",
      payload: {
        app: app,
        analytics: analytics,
      },
    });
  };

  const logAnalyticsEvent = (
    eventName: string,
    options: { [key: string]: any },
  ) => {
    if (state.firebaseAnalytics) {
      logEvent(state.firebaseAnalytics, eventName, options);
    }
  };
  // Initialize Firebase

  return (
    <FirebaseContext.Provider
      value={{
        firebaseInstance: state.firebaseInstance,
        firebaseAnalytics: state.firebaseAnalytics,
        initFirebase,
        logAnalyticsEvent,
      }}
    >
      {children}
    </FirebaseContext.Provider>
  );
};

FirebaseState.propTypes = {
  children: PropTypes.any,
};

export default FirebaseState;
